var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"doc_view"}},[_c('iframe',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.isLoading),expression:"isLoading"}],attrs:{"src":_vm.pdfData}})])}
var staticRenderFns = []

export { render, staticRenderFns }